import {
    CLEAN_REQUEST_MODAL,
  } from './constants'
  
  export function cleanRequestModal() {
    return (dispatch) => {
      dispatch({
        type: CLEAN_REQUEST_MODAL,
      })
      return true
    }
  }
  
  export function reducer(state, action) {
    if (action.type === CLEAN_REQUEST_MODAL) {
        return {
          ...state,
          currentBranchOffice: null,
          verification: null,
          quotes: null,
          request: null,
          budget: null,
          allVAttributes: null,
        }
    }
    else{
        return state
    }
  }
  